import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { DataService } from '../shared/dataservice.service';
import { NotificationsService } from 'angular2-notifications';
import { NWCMPointDef, NWCMStatusMonthData, NWCMPointData, GenResponse } from '../shared/misc-classes';
import { GenService } from '../shared/gen-ser.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ErrorPopupComponent } from '../common/error-popup/error-popup.component';

@Component({
  selector: 'nwcm-tree',
  templateUrl: './nwcm-tree.component.html',
  styleUrls: ['./nwcm-tree.component.css']
})
export class NwcmTreeComponent implements OnInit {

  mId:string = "a81354b1-5310-4597-438a-27e6cb819cef";
  hasmodaccess:boolean = false;
  imgWidth:number = 20;
  widthFactor:number = 1.0;
  heightFactor:number = 1.0;
  refDevWidth:number = 1920;
  refDevHeight:number = 1080;
  editHeader:string = '';
  editNwcTreeDocTs :number = null;

  isLoading:boolean = false;
  isLoaded:boolean = false;
  isFailed:boolean = false;
  isImgLoading:boolean = false;
  kpiImageFlag :boolean = false;
  failMessage:string = '';
  areChangesMade: boolean = false;

  currMonthDtObj: Date = new Date();
  editStatusValue:string = "0";
  editPointRef:NWCMPointDef;

  editDocId:string = "";
  editMonthStr:string = "";
  image = '//placehold.it/100';

  @ViewChild('nwcmimg') imgElt:ElementRef;
  @ViewChild('dummyScrlElement') scrlDiv:ElementRef;

  @ViewChild('childModal') public childModal:ModalDirective;  
  @ViewChild('enlargeImageModal') public enlargeImageModal: ModalDirective;
  @ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;
  
  _pointArray:NWCMPointDef[] = [
     new NWCMPointDef("1",90,165,50,"0","FPY Testing %",""),
    new NWCMPointDef("2",273,235,50,"0","TPT",""),
    new NWCMPointDef("3",710,248,50,"0","Safety Stock",""),
    new NWCMPointDef("4",715,190,50,"0","OTD %",""),
    new NWCMPointDef("5",810,179,50,"0","ROTD %",""),
    new NWCMPointDef("6",928,205,50,"0","Ready & Waiting",""),
    new NWCMPointDef("7",967,250,50,"0","FG Conversion / Diversion",""),
    new NWCMPointDef("8",1250,290,50,"0","Inv Turns Spot",""),
    new NWCMPointDef("9",1250,320,50,"0","Inv Turns Avg",""),
    new NWCMPointDef("10",1862,368,50,"0","FPY Customer PO %",""),
    new NWCMPointDef("11",1810,420,50,"0","Customer PO to PO handover",""),
    new NWCMPointDef("12",1780,470,50,"0","FPY Sale Order %",""),
    new NWCMPointDef("13",1760,500,50,"0","PO receive to SO approval",""),
    new NWCMPointDef("14",1520,480,50,"0","TTPT",""),
    new NWCMPointDef("15",1855,638,50,"0","Advance payment collection",""),
    new NWCMPointDef("16",1855,700,50,"0","Non forecase receivables",""),
    new NWCMPointDef("17",1100,450,50,"0","DIH",""),
    new NWCMPointDef("18",710,638,50,"0","Inventories",""),
    new NWCMPointDef("19",290,548,50,"0","Stock Obsolecence",""),
    new NWCMPointDef("20",210,485,50,"0","Block Stock",""),
    new NWCMPointDef("21",130,558,50,"0","No. of Stock-outs",""),
    new NWCMPointDef("22",320,600,50,"0","Inventories spot %",""),
    new NWCMPointDef("23",240,780,50,"0","Supplier Lead Time",""),
    new NWCMPointDef("24",100,810,50,"0","Supplier OTD",""),
    new NWCMPointDef("25",447,933,45,"0","DPO-Spot",""),
    new NWCMPointDef("26",1384,809,50,"0","DSO-Spot",""),
    new NWCMPointDef("27",1540,808,50,"0","Overdue Spot %",""),
    new NWCMPointDef("28",1711,739,50,"0","Overdue receivables",""),
    new NWCMPointDef("29",1200,1010,60,"0","NWC Spot %","")
  ];
  //_samplePoint:NWCMPointDef = new NWCMPointDef("1",203,59,17,"1");
  

  constructor(public _dataService: DataService,private _notify: NotificationsService) { }

  ngOnInit() {
    this._dataService.currPageName = "Net Working Capital Tree";

    this.loadMonthData();
   // this.goToBottom('srl');
  }

  checkModAccess():boolean{
    if(this._dataService.mAccess(this.mId) == true){
      this.hasmodaccess = true; 
    }
    else{
      this.hasmodaccess = false; 
    }
    return this.hasmodaccess;
  }
  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  hasReadAccess(_pid:string){
    return this._dataService.hasReadAccess(this.mId,_pid);
  }

  imageLoaded(evnt){
    this.redrawPoints();
    this.scrlDiv.nativeElement.scrollIntoView(false);
    //console.log(this.imgElt.nativeElement.offsetWidth);
  }
  imageResized(evnt){
    this.redrawPoints();
    //console.log(this.imgElt.nativeElement.offsetWidth);
  }

  private redrawPoints():void{
    var _tmpImgWidth:number = this.imgElt.nativeElement.offsetWidth;
    var _tmpImgHeight:number = this.imgElt.nativeElement.offsetHeight;
    this.widthFactor =  _tmpImgWidth / this.refDevWidth;
    this.heightFactor =  _tmpImgHeight / this.refDevHeight;
  }

  getNWCMPointLeft(_tmpPoint:NWCMPointDef):string{
    return _tmpPoint.getLeft(this.widthFactor);
  }

  getNWCMPointWidth(_tmpPoint:NWCMPointDef):number{
    return _tmpPoint.getWidth(this.widthFactor);
  }

  getNWCMPointTop(_tmpPoint:NWCMPointDef):string{
    return _tmpPoint.getTop(this.heightFactor);
  }

  public formatMonth(_dateObj: Date): string {
    if (_dateObj) {
      return GenService.getDateFormatStr(_dateObj, "MMM-YYYY");
    }
    return '-';
  }

  PointClicked(_tmpPoint:NWCMPointDef){
    if(_tmpPoint!=null){
      this.editPointRef = _tmpPoint;
      this.editStatusValue = this.editPointRef.Status;
      this.editHeader = this.editPointRef.Title;
      if (this.editPointRef.ImageRef) {
        this.kpiImageFlag = true
        this.isImgLoading = true;
        this._dataService.getKpiImage(this.editPointRef.ImageRef).subscribe((_retVal: boolean) => {
          this.image = this._dataService.KpiImage.Base64Data;
          this.isImgLoading = false;
        });
      } else {
        this.kpiImageFlag = false;
        this.image = '//placehold.it/100';
      }
      this.childModal.show();
    }
    
  }

  editStatusChanged(_newStatus:string){
    this.editStatusValue = _newStatus;
  }

  public discardChanges():void {
    this.childModal.hide();
    
    this.scrlDiv.nativeElement.scrollIntoView(false);
  }
  public hideChildModal():void{
    this.childModal.hide();
    
    this.scrlDiv.nativeElement.scrollIntoView(false);    
  }

  public dataEdited():void{
    if(this.editPointRef){
      this.editPointRef.Status = this.editStatusValue;
      this.areChangesMade = true;
    }
    this.childModal.hide();
    
    this.scrlDiv.nativeElement.scrollIntoView(false);
  }
  public getPointStatusSrc(_tmpStatus):string{
    switch(_tmpStatus){
      case "0":
        return "/assets/rad-grey.png";  
      case "1":
        return "/assets/rad-green.png";  
      case "2":
        return "/assets/rad-yellow.png";  
      case "3":
        return "/assets/rad-red.png";  
    }

    return "/assets/rad-grey.png";
  }
  public prevMonthSel(): void {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }
  public nextMonthSel() {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }
  
  loadMonthData() {
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade = false;
    this._dataService.loadNwcmTreeStatus(this.currMonthDtObj).subscribe((_nwcmMonthData: NWCMStatusMonthData) => {
      this.editDocId = "";
      this.editMonthStr = "";
      this.editNwcTreeDocTs = null;
      this._pointArray.forEach((_tmpPointDef:NWCMPointDef)=>{
        _tmpPointDef.Status = "0";
        _tmpPointDef.ImageRef = "";
      });
       if (_nwcmMonthData != null) {
        this.editDocId = _nwcmMonthData.ID;
        this.editMonthStr = _nwcmMonthData.SelMonth;
        this.editNwcTreeDocTs = _nwcmMonthData.docTs;
        _nwcmMonthData.Points.forEach((_tmpNwcmPoint:NWCMPointData) => {
          this._pointArray.forEach((_tmpPointDef:NWCMPointDef)=>{
            if(_tmpNwcmPoint.KPIId == _tmpPointDef.PointId){
              _tmpPointDef.Status = _tmpNwcmPoint.KPIStatus;
              _tmpPointDef.ImageRef = _tmpNwcmPoint.KPIImageRef;
            }
          });
        });
        // this.isLoaded = true;
        // this.isLoading = false;
        // this.isFailed = false;
       }
      // else {
      //   this.isLoaded = false;
      //   this.isLoading = false;
      //   this.isFailed = true;
      //   this.failMessage = "Failed to get data from database, try again";
      //  }
      this.isLoaded = true;
      this.isLoading = false;
      this.isFailed = false;
    });
  }

  saveData(_sendMail: boolean):void{
    if(this.validateData()==true){
      if(this.editMonthStr == ""){
        this.editMonthStr = GenService.getDateFormatStr(this.currMonthDtObj,"YYYYMM")
      }
      let _nwcmPointAr:Array<NWCMPointData> = [];
      for(var i=0;i<this._pointArray.length;i++){
        _nwcmPointAr.push(new NWCMPointData(this._pointArray[i].PointId,this._pointArray[i].Status,this._pointArray[i].ImageRef,[]));
      }
      let _nwcmMonthObj:NWCMStatusMonthData = new NWCMStatusMonthData(this.editDocId,this.editMonthStr,_nwcmPointAr,this.editNwcTreeDocTs);
      this._dataService.saveNWCMTreeInfo(_nwcmMonthObj)
      .subscribe((resp:GenResponse) => {
        if(resp.status == "FAIL"){
          if (resp.errorCode == DataService.staleDataCode) {
            this.errorPopup.showErrorPopup("Stale Data", resp.details)
          } else {
            this._notify.error('Failure', resp.details, this._dataService.failureOptions);
          }
        }
        else{
          this._notify.success('Success',resp.details,this._dataService.successOptions);
          this.loadMonthData();
        }
      });
    }
  }

  validateData():boolean{
    return true;
  }
  discardData():void{
    this.loadMonthData();
  }

  goToBottom(location: string): void {
    setTimeout(() => {
      window.location.hash = location;  
    }, 10);
    
  }
  openEnlargeImageModal():void{
    this.enlargeImageModal.show();
  }
  closeEnlargeImageModal(){
    this.enlargeImageModal.hide();
  }
}
